{
  "nl": {
    "posts": {
      "index": {
        "title": "Nieuws van fobizz",
        "empty": "Er is momenteel geen nieuws voor deze taal.",
        "error": "Het nieuws kon niet worden geladen. Probeer het later opnieuw.",
        "pinnedAria": "Vastgezet bericht",
        "publishedAt": "Gepubliceerd op {date}"
      }
    }
  }
}
